module.exports = __webpack_public_path__ + "static/napom-446c6597f0ce147cb85b6c8e717a29be.jpg";